import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProductDetail, ProductDocument } from '../interfaces/product-detail.model';

export interface PlcLookupItem {
  value: string;
  label: string;
  type: string;
}

interface PlcLookupResponse {
  plc: PlcLookupItem[] | null;
}

export interface ProductFiltersResponse {
  tipiOlio: PlcLookupItem[] | null;
  segmentiMercato: PlcLookupItem[] | null;
}

@Injectable({ providedIn: 'root' })
export class ProductsService {
  constructor(private http: HttpClient) {}

  getPlc1Options(): Observable<PlcLookupResponse> {
    return this.http.get<PlcLookupResponse>('api/lookup/categoriaPlc1');
  }

  getPlc2Options(): Observable<PlcLookupResponse> {
    return this.http.get<PlcLookupResponse>('api/lookup/settoreplc2');
  }

  getProductFilters(): Observable<ProductFiltersResponse> {
    return this.http.get<ProductFiltersResponse>('api/prodotticatalogo/filtri');
  }

  getProductDetail(productId: string): Observable<ProductDetail> {
    return this.http.get<ProductDetail>(`api/prodottodettaglio/${productId}`);
  }

  getFeaturedProducts(): Observable<any> {
    return this.http.post<any>('api/prodotticatalogo/evidenza', {});
  }

  getCatalogProducts(page: number, pageSize: number, payload: any): Observable<any> {
    return this.http.post<any>('api/prodotticatalogo/list', payload, {
      params: { page, pageSize },
    });
  }

  getGroupedProducts(page: number, pageSize: number, payload: any): Observable<any> {
    return this.http.post<any>('api/prodotticatalogo/raggruppati/list', payload, {
      params: { page, pageSize },
    });
  }

  getProductDocuments(idProdotto: string): Observable<ProductDocument[]> {
    return this.http.get<ProductDocument[]>(`api/DocumentiProdotto/${idProdotto}`);
  }

  exportPriceList(format: 'xlsx' | 'pdf', payload: any): Observable<Blob> {
    return this.http.post('api/DocumentiExport/listino-agenti', payload, {
      params: { formato: format },
      responseType: 'blob',
    });
  }

  downloadProductDocument(idAsset: number): Observable<Blob> {
    return this.http.get(`api/DocumentiProdotto/asset/${idAsset}`, {
      responseType: 'blob',
    });
  }
}
